import React from 'react';
import PropTypes from 'prop-types';

// Import image
import ClearIcon from '~/common/images/icon-clear.png';

// Import Local Styles
import styles from './clear-search-button.css';

const ClearSearchButton = (props) => {
    const { id, onClick } = props;
    return (
        <a
            className={styles.btn}
            id={id}
            onClick={onClick}
            onMouseDown={e => e.preventDefault() /* prevents button from stealing focus */}
        >
            <img className={styles.img} src={ClearIcon} />
        </a>
    );
};

ClearSearchButton.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func
};

export default ClearSearchButton;
